"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// TODO get metrics-specific colors into the design-approved
// common styles to shrare across web and phoenix
exports.MetricBlue = '#2A79AF';
exports.MetricBlueLight = 'rgba(42, 121, 175, 0.4)';
exports.BreakPoints = {
    'SMALL': 375,
    'MEDIUM': 768,
    'LARGE': 1024,
};
//# sourceMappingURL=styles.js.map